import axios from '../axios'
// 单独导出
export const login = (data) => {
  return axios({
    url: '/con/user/login',
    method: 'POST',
    data: data
  })
}
// 登出
export const logout = () => {
  return axios({
    url: '/logout',
    method: 'get'
  })
}
// 登出
export const changePASS = (data) => {
  return axios({
    url: '/con/user/modifyPassWord',
    method: 'POST',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/login.js